<template>
  <div class="authorization">
      <div class="topBtn">
          <el-button class="button" type="success" size="mini" @click="expandAll()">展开</el-button>
          <el-button class="button" type="warning" size="mini" @click="foldAll()">收起</el-button>
        </div>
      <div class="treeBox">
        <div class="usersContainer">
          <el-tree
            :highlight-current="true"
            ref="roleTree"
            :data="datas"
            v-loading="loading"
            v-if="expanded"
            show-checkbox
            node-key="id"
            :default-expand-all="expandAlls"
            :default-checked-keys="arr"
            :props="defaultProps">
          </el-tree>
        </div>
      </div>
      <div class="footer">
        <el-button class="button" type="primary" size="mini" @click="submit">确认</el-button>
        <el-button class="button" type="danger" size="mini" @click="closePopup">关闭</el-button>
      </div>
    </div>
</template>
<script>
import httpKit from '../../../../dxrj.sdk/js/kit/httpKit';

export default {
  props: {
    params: Object
  },
  data() {
    return {
      elTrees: true,
      loading: false,
      expanded: true,
      expandAlls: false,
      arr: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      datas: [],
      users: [],
      homeData: [{
        title: '权限列表'
      }],
      acId: [],
      roleKey: null
    };
  },
  mounted() {
    this.getRoleAuth();
  },
  methods: {
    // 展开收起tree
    expandAll() {
      this.expanded = false;
      this.expandAlls = true;
      this.$nextTick(() => {
        this.expanded = true;
      });

      // this.changeNodeAll(this.$refs.roleTree.store.root);
      // this.changeExpandAll(this.$refs.roleTree.store.nodesMap);
    },
    foldAll() {
      this.expanded = false;
      this.expandAlls = false;
      this.$nextTick(() => {
        this.expanded = true;
      });

      // this.changeNodeAll(this.$refs.roleTree.store.root);
      // this.changeExpandAll(this.$refs.roleTree.store.nodesMap);
    },
    changeNodeAll(node){
      node.expanded = this.expandAlls;
      for (let i = 0; i < node.childNodes.length; i++) {
        node.childNodes[i].expanded = this.expandAlls;
        if(node.childNodes[i].childNodes.length > 0){
          this.changeExpandAll(node.childNodes[i]);
        }
      }
    },
    changeExpandAll(node){
      for (let item in node) {
        node[item].expanded = this.expandAlls;
      }
    },
    getRoleAuth() {
      let par = {
        roleId: this.params.id
      };
      httpKit.post($api_eap.role.searchby, par).then(res => {
        if (res.data.code === '200') {
          res.data.data.map(item => {
            if (item.id) {
              this.arr.push(item.id);
            }
          });
          this.getTree();
        }
      });
    },
    getTree() {
      let pom = {
        roleId: this.params.id
      };
      this.loading = true;
      httpKit.post($api_eap.menu.roleTree, pom).then(res => {
        this.loading = false;
        if (res.data.code === '200') {
          if (res.data.data.length) {
            this.datas = res.data.data[0].children
          }
        }
      });
    },
    submit() {
      let str = this.$refs.roleTree.getCheckedKeys().join();
      let loading = this.$loading({text:'绑定中，请稍后'});
      let par = {
        roleId: this.params.id,
        menuIds: str
      };
      httpKit.post($api_eap.role.bindMenu, par).then(res => {
        if (res.data.code === '200') {
          this.$message.success(res.data.msg);
          this.$emit('users');
          loading.close();
        } else {
          this.$message.error(res.data.msg);
          loading.close();
        }
      });
    },
    closePopup() {
      this.$emit('close');
    }
  }
};
</script>
<style scoped lang="less">
  .authorization{
    .topBtn{
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .treeBox{
      padding-left: 100px;
      width: 420px;
      height: 460px;
      overflow: auto;
      .usersContainer{
        width: 280px;
      }
    }
    .footer{
      padding:15px 0;
      text-align: center
    }
    .button {
      width: 120px;
    }
    .buttons {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
